// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".client-Components-Calendar-WeekDays-module__root--Vr0ez {\n  display: contents;\n}\n/*# sourceMappingURL=WeekDays.module.css.map */", "",{"version":3,"sources":["webpack://./WeekDays.module.less","webpack://./client/Components/Calendar/WeekDays.module.less"],"names":[],"mappings":"AAAA;EACC,iBAAA;ACCD;AACA,8CAA8C","sourcesContent":[".root {\n\tdisplay: contents;\n}",".root {\n  display: contents;\n}\n/*# sourceMappingURL=WeekDays.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "client-Components-Calendar-WeekDays-module__root--Vr0ez"
};
export default ___CSS_LOADER_EXPORT___;
